import { BehaviorSubject } from 'rxjs';
import { TextContent } from './text-content.model';
import TextContentRepository from './text-content.repository';

interface IState {
  current?: TextContent;
  loading_current: boolean;
  items: TextContent[];
  loading_items: boolean;
  saving: boolean;
  errors: string[];
}

const initialState: IState = {
  loading_current: false,
  items: [],
  loading_items: false,
  saving: false,
  errors: [],
};

export class TextContentStore {
  private _state: BehaviorSubject<IState> = new BehaviorSubject(initialState);
  get state$() {
    return this._state.asObservable();
  }
  get state() {
    return this._state.value;
  }
  updateState(model: IState) {
    this._state.next(model);
  }

  constructor(private repository: TextContentRepository) {}

  getByName = (name: string) => {
    this.updateState({ ...this.state, current: undefined, loading_current: true, errors: [] });
    this.repository.getByName(name).then(this.setCurrentSuccess).catch(this.setCurrentFailure);
  };

  setCurrentSuccess = (value?: TextContent) => {
    this.updateState({ ...this.state, current: value, loading_current: false });
  };

  setCurrentFailure = (error: any) => {
    this.updateState({
      ...this.state,
      current: undefined,
      loading_current: false,
      errors: [JSON.stringify(error)],
    });
    console.log(error);
  };

  add = async (value: TextContent) => {
    this.updateState({ ...this.state, errors: [], saving: true });

    const valid = await this.repository
      .validator(value, 'add')
      .then(value => value === true)
      .catch(this.saveFailure);

    if (valid) {
      return this.repository.add(value).then(this.saveSuccess).catch(this.saveFailure);
    }
  };

  saveSuccess = (value: boolean) => {
    if (value !== true) {
      this.updateState({ ...this.state, errors: ['Fail on add user'], saving: false });
      return;
    }
    this.updateState({ ...this.state, errors: [], saving: false });
    return 'Registro salvo com sucesso.';
  };

  saveFailure = (error: any) => {
    this.updateState({
      ...this.state,
      errors: typeof error === 'string' ? [error] : [JSON.stringify(error)],
      saving: false,
    });
  };

  removeItem = async (name: string) => {
    this.updateState({ ...this.state, loading_current: true });
    return await this.repository
      .remove(name)
      .then(this.setRemoveSuccess)
      .catch(this.setCurrentFailure);
  };

  setRemoveSuccess = () => {
    console.log('setRemoveSuccess', this.state.current?.content);
    const item = new TextContent();
    item.content = '';
    this.updateState({ ...this.state, current: item, loading_current: false });
    return 'Registro excluído com sucesso.';
  };
}
